import React from 'react';
import { Sentry } from '@/lib/sentry';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

function DefaultFallback({ resetError }: { resetError: () => void }) {
  return (
    <div className="flex justify-center items-center py-10">
      <div className="text-center">
        <p className="text-gray-600">Something went wrong loading this content.</p>
        <button
          onClick={resetError}
          className="mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Try again
        </button>
      </div>
    </div>
  );
}

export function ErrorBoundary({ children, fallback }: ErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => fallback ?? <DefaultFallback resetError={resetError} />}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
